const NotificationIcon = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M9.99935 14.8704C14.6987 14.8704 16.8727 14.2676 17.0827 11.8478C17.0827 9.42973 15.567 9.58522 15.567 6.61832C15.567 4.30085 13.3704 1.66406 9.99935 1.66406C6.62833 1.66406 4.43172 4.30085 4.43172 6.61832C4.43172 9.58522 2.91602 9.42973 2.91602 11.8478C3.12681 14.2767 5.30083 14.8704 9.99935 14.8704Z" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.9894 17.375C10.8526 18.6373 9.07929 18.6522 7.93164 17.375" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}

export default NotificationIcon